<template>
    <div class="text">
        <h6>You get the best of the best</h6>
        <ul class="list">
            <li class="list__item">
                <AppIcon modifier="checkmark" class="list__style list__style--checkmark"/>
                Super high quality and only 3M material
            </li>
            <li class="list__item">
                <AppIcon modifier="checkmark" class="list__style list__style--checkmark"/>
                Extra fast shipping and strict policy
            </li>
            <li class="list__item">
                <AppIcon modifier="checkmark" class="list__style list__style--checkmark"/>
                Leading high quality reflector manufacturer
            </li>
            <li class="list__item">
                <AppIcon modifier="checkmark" class="list__style list__style--checkmark"/>
                Top quality, all products made in EU, Estonia
            </li>
            <li class="list__item">
                <AppIcon modifier="checkmark" class="list__style list__style--checkmark"/>
                All products meet REACH and are made according to EU regulations
            </li>
        </ul>
    </div>
</template>

<script>
import AppIcon from '../AppIcon';

export default {
  components: {
    AppIcon,
  },
};
</script>
